import { defineMessages } from 'react-intl'

export default defineMessages({
  triggerSetup: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.triggerSetup',
    defaultMessage: 'Trigger Setup'
  },
  loading: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.loading',
    defaultMessage: 'Loading...'
  },
  selectTriggerSource: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.selectTriggerSource',
    defaultMessage: 'Select trigger source'
  },
  object: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.object',
    defaultMessage: 'object'
  },
  pleaseSelectTriggerSource: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.pleaseSelectTriggerSource',
    defaultMessage: 'Please select a trigger source'
  },
  triggerEvent: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.triggerEvent',
    defaultMessage: 'What events should trigger the workflow?'
  },
  selectTriggerEvent: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.selectTriggerEvent',
    defaultMessage: 'Select a trigger event'
  },
  pleaseSelectTriggerEvent: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.pleaseSelectTriggerEvent',
    defaultMessage: 'Please select a trigger event'
  },
  watchedFields: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.watchedFields',
    defaultMessage: 'What {triggerEvent} changes would you like to track?'
  },
  selectFields: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.selectFields',
    defaultMessage: 'Select all fields that apply'
  },
  removeFieldHint: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.removeFieldHint',
    defaultMessage: 'Remove {fieldName}'
  },
  triggerDataSourceRemovedError: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceEventTrigger.deletedSourceError',
    defaultMessage:
      'The data source for this trigger has been removed, please delete this trigger and create a new one.'
  },
  polling5MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling5MinutesDisplay',
    defaultMessage: 'Every 5 minutes'
  },
  polling10MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling10MinutesDisplay',
    defaultMessage: 'Every 10 minutes'
  },
  polling15MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling15MinutesDisplay',
    defaultMessage: 'Every 15 minutes'
  },
  polling30MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling30MinutesDisplay',
    defaultMessage: 'Every 30 minutes'
  },
  polling1HourDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling1HourDisplay',
    defaultMessage: 'Every hour'
  },
  polling6HoursDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling6HoursDisplay',
    defaultMessage: 'Every 6 hours'
  },
  polling12HoursDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling12HoursDisplay',
    defaultMessage: 'Every 12 hours'
  },
  polling24HoursDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling24HoursDisplay',
    defaultMessage: 'Every 24 hours'
  }
})
